export default [
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Alias',
    },
    cell: {
      type: 'text',
      value: (e) => e.name,
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'notificationType',
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Message type',
    },
    cell: {
      type: 'slot',
      name: 'messageType',
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Destination type',
    },
    cell: {
      type: 'slot',
      name: 'destinationType',
    },
  },
];
